import {
    locationicon,
    scheduleicon,
    webinarlogo,
    webinarlogo2,
    webinarlogo3,
    webinarlogo4,
    webinarlogo5
} from 'src/assets/images'
import styles from './exclusivewebinar.module.scss'
import { Col, Row } from 'react-bootstrap'
import { title } from 'process';
type TWebinar = {
    title: string,
    image: string
}
export default function ExclusiveWebinar() {
    const webinarArr: TWebinar[] = [
        {
            title: 'Zero to MVP: The Speed Advantage',
            image: webinarlogo
        },
        {
            title: '0 to 1: The founder’s first Battle',
            image: webinarlogo2
        },
        {
            title: 'The Art of the Pitch: Tell, Sell & Close',
            image: webinarlogo3
        },
        {
            title: 'Beyond Payments: Razorpay way',
            image: webinarlogo4
        },
        {
            title: 'Unfiltered: A Founder’s Journey',
            image: webinarlogo5
        }
    ]
    return (
        <section className={styles.exclusivewebinar}>
            <div className={styles.container}>
                <h3 className={styles.sectionHeading}>Exclusive Webinars</h3>
                <div className={styles.webinars}>
                    {webinarArr.map((webinar: TWebinar, i: number) => (
                        <div className={styles.webinarCard} key={i}>
                            <img src={webinar.image} alt="webinarlogo" className={styles.webinarimage} />
                            <div className={styles.content}>
                                <h5 className={styles.title}>{webinar.title}</h5>
                                <p className={styles.detail}><img src={scheduleicon} alt="calendar" />To be Announced</p>
                                <p className={styles.detail}><img src={locationicon} alt="location" />Online</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
